import { lazy } from 'react';
import MainLayout from 'Layouts/Main/Main';

const AppointmentsList = lazy(() => import('Containers/Appointment/AppointmentsList/AppointmentsList'));
const AppointmentDetails = lazy(() => import('Containers/Appointment/AppointmentDetails/AppointmentDetails'));

const routes = [
  {
    path: '/appointments',
    exact: true,
    ContentComponent: AppointmentsList,
    Layout: MainLayout,
    name: 'Appointment',
  },
  {
    path: '/appointments/:id',
    exact: true,
    ContentComponent: AppointmentDetails,
    Layout: MainLayout,
    name: 'Appointment Detail',
  },
];

export default routes;
